var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex-table-row d-flex align-items-center draw-table-row" },
    [
      _c("div", { staticClass: "draw-column column c-winner-name" }, [
        _c("span", { staticClass: "winner-number" }, [
          _vm._v(_vm._s(this.winner.position))
        ]),
        _vm._v("\n    of " + _vm._s(this.winnerCount) + "\n  ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "draw-column column c-first-name" }, [
        _vm._v(
          _vm._s(
            this.winner.selectedAttendee.firstname
              ? this.winner.selectedAttendee.firstname
              : "-"
          )
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "draw-column column c-last-name" }, [
        _vm._v(
          _vm._s(
            this.winner.selectedAttendee.lastname
              ? this.winner.selectedAttendee.lastname
              : "-"
          )
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "draw-column column c-email" }, [
        _vm._v(
          _vm._s(
            this.winner.selectedAttendee.email
              ? this.winner.selectedAttendee.email
              : "-"
          )
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "draw-column column c-attendee",
          class: { empty_attendees: !this.winner.selectedAttendee.attendee_no }
        },
        [
          this.winner.selectedAttendee.attendee_no
            ? _c(
                "a",
                { attrs: { href: this.attendeeLink, target: "_blank" } },
                [
                  _vm._v(
                    _vm._s(
                      this.winner.selectedAttendee.attendee_no
                        ? this.winner.selectedAttendee.attendee_no
                        : "-"
                    )
                  )
                ]
              )
            : [_vm._v("-")]
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "draw-column column c-ticket" }, [
        _vm._v(
          _vm._s(
            this.winner.selectedAttendee.ticket_no
              ? this.winner.selectedAttendee.ticket_no
              : "-"
          )
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "draw-column column c-draw-status" }, [
        this.winner.status === "accept"
          ? _c("div", { staticClass: "alert alert-success" }, [
              _vm._v("confirmed")
            ])
          : _vm._e(),
        _vm._v(" "),
        this.winner.status === "respin" || this.winner.status === "move"
          ? _c(
              "div",
              { staticClass: "alert alert-reject", attrs: { role: "alert" } },
              [_vm._v("rejected")]
            )
          : _vm._e(),
        _vm._v(" "),
        this.winner.status === "skip" &&
        this.nonReSpinnable.indexOf(this.winner.position) < 0 &&
        !this.drawn
          ? _c("div", { staticClass: "skip-container" }, [
              _c(
                "div",
                { staticClass: "alert alert-skip", attrs: { role: "alert" } },
                [_vm._v("skipped")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "skip",
                  on: {
                    click: function($event) {
                      return _vm.reDraw()
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("../assets/images/skipped.svg"),
                      alt: "skipped button"
                    }
                  })
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        this.winner.status === "skip" &&
        (this.drawn || this.nonReSpinnable.indexOf(this.winner.position) >= 0)
          ? _c("div", { staticClass: "alert alert-skipped" }, [
              _vm._v("skipped")
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "draw-column column type-date c-time" }, [
        _vm._v(
          "\n    " + _vm._s(_vm.formatDate(this.winner.createdAt)) + "\n    "
        ),
        _c("span", [_vm._v(_vm._s(_vm.formatTime(this.winner.createdAt)))])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "draw-column column c-reject",
          attrs: { title: this.winner.reason }
        },
        [_vm._v(_vm._s(this.winner.reason ? this.winner.reason : "-"))]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c018b680", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c018b680","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DrawTableRow.vue
// module id = null
// module chunks = 